<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pi_inoutno }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pi_class">
            <label class="weui-form-preview__label">{{customLabel.pi_class || "单据类型"}}</label>
            <em class="weui-form-preview__value">{{
              '库存初始化'
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="pi_date">
            <label class="weui-form-preview__label">{{customLabel.pi_date || "单据日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'"
              >{{ form.main.pi_date }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="pi_whname">
            <label class="weui-form-preview__label">{{customLabel.pi_whname || "仓库"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.pi_whname }}
            </span>
          </div>
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"          
        >
          <div class="form-detail-preview_num">{{ item.pd_pdno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
              <span class="weui-form-preview__value">{{
                item.pr_detail
              }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.pr_orispeccode" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{
                item.pr_orispeccode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_inqty">
              <label class="weui-form-preview__label">{{customLabel.pd_inqty || "数量"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_inqty
              }} {{ item.pr_unit }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_qty_extra">
              <label class="weui-form-preview__label">{{customLabel.pd_qty_extra || "辅助数量"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_qty_extra
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_madein">
              <label class="weui-form-preview__label">{{customLabel.pd_madein || "产地"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_madein
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_batchcode">
              <label class="weui-form-preview__label">{{customLabel.pd_batchcode || "批次号"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_batchcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_madetime">
              <label class="weui-form-preview__label">{{customLabel.pd_madetime || "生产日期"}}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
                item.pd_madetime
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_shelflife">
              <label class="weui-form-preview__label">{{customLabel.pd_shelflife || "保质期（天）"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_shelflife
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_lifedate">
              <label class="weui-form-preview__label">{{customLabel.pd_lifedate || "保质期"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_lifedate
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_price">
              <label class="weui-form-preview__label">{{customLabel.pd_price || "成本单价（不含税）"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_price
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_total">
              <label class="weui-form-preview__label">{{customLabel.pd_total || "金额（元）"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_total
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_prodcode">
              <label class="weui-form-preview__label">{{customLabel.pd_prodcode || "物料编号"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_prodcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_brand">
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "厂家/品牌"}}</label>
              <span class="weui-form-preview__value">{{
                item.pr_brand
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{
                item.pr_spec
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_remark">
              <label class="weui-form-preview__label">{{customLabel.pd_remark || "备注"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_remark
              }}</span>
            </div>
          </custom-layout>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/stock/in_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/storage/prodinout",
      codeField: "pi_inoutno",
      statusField: "pi_statuscode",
      caller: 'ProductInit',
      xtype:'stock-productinit-formpanel'
    };
  }
}
</script>